import React from 'react';
import { Facebook } from 'components/Icons/Social';

export default props => {
    return  <a href={'https://www.facebook.com/ZipperTic/'} title='Facebook' {...props}><Facebook /></a>;
}